import axios from "axios";

export const fetchMaintenanceConfig = () => {
  return axios.get("/app-config?platform=web");
};
